var builtinPlacements = function builtinPlacements(isMain) {
  return {
    topLeft: {
      points: ['bl', 'tl'],
      overflow: {
        shiftX: 50,
        adjustY: true
      },
      offset: [0, 0],
      targetOffset: [10, 0]
    },
    bottomLeft: {
      points: ['tl', 'bl'],
      overflow: {
        adjustX: true,
        adjustY: true
      }
    },
    top: {
      points: ['bc', 'tc'],
      overflow: {
        shiftX: 50,
        adjustY: true
      },
      offset: [0, -10]
    },
    bottom: {
      points: ['tc', 'bc'],
      overflow: {
        shiftX: true,
        adjustY: true
      },
      offset: [0, 10],
      htmlRegion: 'scroll'
    },
    left: {
      points: ['cr', 'cl'],
      overflow: {
        adjustX: true,
        shiftY: true
      },
      offset: [-10, 0]
    },
    right: {
      points: ['tl', 'tr'],
      overflow: {
        adjustX: true,
        shiftY: 24
      },
      offset: [isMain ? 12 : 0, 0]
    }
  };
};
export default builtinPlacements;